import { useEffect } from "react";
import { X } from "lucide-react";
import useDismiss from "./useDismiss";
import styles from "./Drawer.module.css";

export default function Drawer({ open, title, onClose, footer, children }) {
  useDismiss(open, onClose);

  // Keep the page behind from scrolling while the drawer is open
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div className={styles.overlay} onPointerDown={(event) => event.target === event.currentTarget && onClose()}>
      <aside className={`${styles.panel} d-flex flex-column`} role="dialog" aria-modal="true" aria-label={title}>
        <header className={`${styles.header} d-flex align-items-center justify-content-between`}>
          <h2 className={styles.title}>{title}</h2>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
            <X size={24} strokeWidth={1.75} />
          </button>
        </header>
        <div className={styles.body}>{children}</div>
        {footer ? <footer className={`${styles.footer} d-flex justify-content-end`}>{footer}</footer> : null}
      </aside>
    </div>
  );
}
